import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  NavLink, Route, Switch, useHistory, useRouteMatch,
} from 'react-router-dom';
import RemoteSensing from './components/RemoteSensing';
import PreviousReports from '../../../PreviousReports/PreviousReports';
import StageReport from '../../../StageReport';
import DetermineZone from './components/DetermineZone';

const MonitoringData = ({ stagesInfo, currentStage, isProjectFinished, projectStatus }) => {
  const translate = useIntl();
  const { path, url } = useRouteMatch();
  const history = useHistory();
  const [monitoringZoneCheck, setMonitoringZoneCheck] = useState(false);

  useEffect(() => {
    const currentSubZone = stagesInfo?.find((item) => item.stage === currentStage);
    if (currentSubZone || isProjectFinished) {
      setMonitoringZoneCheck(true);
    } else {
      setMonitoringZoneCheck(false);
    }
  }, []);
  const TabsData = {
    ...(!isProjectFinished && {
      0: {
        label: translate.formatMessage({ id: 'monitoringData.currentStage' }),
        content: monitoringZoneCheck ? <StageReport /> : <DetermineZone projectStatus={projectStatus} />,
        link: '',
        path: `${path}`,
        tabId: 0,
      },
    }),
    ...((projectStatus !== 'register' && currentStage !== 0) ? {
      1: {
        label: translate.formatMessage({ id: 'monitoringData.previousStages' }),
        content: <PreviousReports />,
        link: '/previous-stages',
        path: `${path}/previous-stages`,
        tabId: 1,
      },
    } : null),
    2: {
      label: translate.formatMessage({ id: 'monitoringData.remoteSensing' }),
      content: <RemoteSensing />,
      link: '/remote-sensing',
      path: `${path}/remote-sensing`,
      tabId: 2,
    },
  };
  useEffect(() => {
    if (isProjectFinished) history.push(`${url}/previous-stages`);
  }, [isProjectFinished]);
  return (
    <div className="project__monitoring">
      <div className="tabs-monitoring">
        {Object.values(TabsData).map((tab) => (
          <NavLink
            key={tab.tabId}
            to={`${url}${tab.link}`}
            className="tab-link"
            activeClassName="tab-link_active"
            exact
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
      <div className="dividing-line" />
      <Switch>
        {Object.values(TabsData).map((tab, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Route key={index} path={tab.path} exact>
            {tab.content}
          </Route>
        ))}
      </Switch>
    </div>
  );
};

export default MonitoringData;
